module.exports = __webpack_public_path__ + "img/shdh.b2335d3b.png";